import { clientServerPydanticAI } from "shared/api/axios";
import { createURL } from "shared/api/utils";

interface PostFeedbackRequest {
  threadId: string;
  messageId: string;
  positiveFeedback: boolean;
  comment?: string;
}

export const postMessageFeedback = async ({
  threadId,
  messageId,
  positiveFeedback,
  comment,
}: PostFeedbackRequest): Promise<void> => {
  try {
    await clientServerPydanticAI.post(
      createURL(["threads", threadId, "messages", messageId, "feedback"]),
      { positive_feedback: positiveFeedback, comment }
    );
  } catch (error) {
    console.error("Failed to post message feedback", error);
    throw error;
  }
};
